/* This file is autogenerated, see readme.md for instructions */
import WebhookSvgIcon from '@bloomreach/banana-theme/icons/webhook.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WebhookIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WebhookSvgIcon />
    </Icon>
  );
});

WebhookIcon.displayName = 'WebhookIcon';

export default WebhookIcon;
